import React from 'react';
import './TabNavigation.css';

function TabNavigation({ activeTab, onTabChange, tabs }) {
  return (
    <div className="tab-navigation">
      <div className="tab-container">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            <div className="tab-content">
              {tab.icon && <span className="tab-icon">{tab.icon}</span>}
              <span className="tab-label">{tab.label}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default TabNavigation;